import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@/components/atoms';
import RunningWithErrors from '@/assets/img/RunningWithErrors.png';
import usePageTitle from '@/hooks/usePageTitle';
import {useIntl} from 'react-intl';
import styles from './ErrorContent.module.scss';

const ErrorContent = ({errorType = '404', isLoading, onGoHome}) => {
  const {formatMessage} = useIntl();

  usePageTitle(formatMessage({id: `PAGE_ERROR.${errorType}_HEADER`}));

  return (
    <div className={styles.errorContent} data-testid='error-page'>
      <div className={styles.logo}>
        <img
          src={RunningWithErrors}
          alt='Page Not Found Icon'
          style={{height: 64, width: 64, objectFit: 'contain'}}
        />
      </div>
      <div className={styles.header}>
        {formatMessage({id: `PAGE_ERROR.${errorType}_HEADER`})}
      </div>
      <div className={styles.subheader}>
        {formatMessage({id: `PAGE_ERROR.${errorType}_SUBHEADER`})}

        <div className={styles.reasons}>
          <div className={styles.reasonsTitle}>
            {formatMessage({
              id: `PAGE_ERROR.${errorType}_REASONS_TITLE`,
              defaultMessage: 'Possible Reasons'
            })}
          </div>
          <ul className={styles.reasonList}>
            <li>
              {formatMessage({
                id: `PAGE_ERROR.${errorType}_REASON_1`,
                defaultMessage: 'The page may have been removed'
              })}
            </li>
            <li>
              {formatMessage({
                id: `PAGE_ERROR.${errorType}_REASON_2`,
                defaultMessage: 'The page may have had its name changed'
              })}
            </li>
            <li>
              {formatMessage({
                id: `PAGE_ERROR.${errorType}_REASON_3`,
                defaultMessage: 'The page is temporarily unavailable'
              })}
            </li>
          </ul>
        </div>
      </div>
      <div className={styles.actions}>
        {/* <Button
          handleButton={onHelp}
          uiSchema={{
            title: formatMessage({ id: `PAGE_ERROR.HELP_BUTTON`, defaultMessage: 'Help' }),
            className: styles.button,
            variant: "secondary",
            isLoading: isLoading,
          }}
          data-testid="btn-help"
        /> */}
        <Button
          handleButton={onGoHome}
          uiSchema={{
            title: 'Go to Homepage',
            className: styles.button,
            isLoading: isLoading
          }}
          data-testid='btn-go-home'
        />
      </div>
    </div>
  );
};

ErrorContent.propTypes = {
  errorType: PropTypes.string,
  isLoading: PropTypes.bool,
  onGoHome: PropTypes.func.isRequired
};

ErrorContent.defaultProps = {
  errorType: '404',
  isLoading: false
};

export default ErrorContent;
